import React, { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa"; // أيقونة السهم

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      {visible && (
        <button
          onClick={scrollToTop}
          style={{
            position: "fixed",
            bottom: "40px",
            right: "40px",
            backgroundColor: "#FF4500",
            color: "#fff",
            border: "none",
            borderRadius: "50%",
            width: "50px",
            height: "50px",
            cursor: "pointer",
            fontSize: "24px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.3)",
            zIndex: 1000,
            transition: "transform 0.3s ease, box-shadow 0.3s ease",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          onMouseEnter={e => e.currentTarget.style.transform = "scale(1.2)"}
          onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
        >
          <FaArrowUp />
        </button>
      )}
    </>
  );
}
